import { render } from "./LogoHeader.vue?vue&type=template&id=40722b50&scoped=true"
import script from "./LogoHeader.vue?vue&type=script&lang=js"
export * from "./LogoHeader.vue?vue&type=script&lang=js"

import "./LogoHeader.vue?vue&type=style&index=0&id=40722b50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40722b50"]])

export default __exports__